// extracted by mini-css-extract-plugin
export var closeButton = "_37-3";
export var header = "_37-0";
export var link = "_37-1";
export var retryButton = "_37-2";